import React from 'react'
import { Col, ListGroup, Badge } from 'react-bootstrap'
import { format, parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { FaTrophy } from 'react-icons/fa'

function BidList({ bid, isCurrentUserBid }) {
  // Parse the date and format it
  const dateObject = parseISO(bid.createdAt);
  const serverTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const zonedDate = utcToZonedTime(dateObject, serverTimezone);
  const formattedDate = format(zonedDate, 'dd MMMM yyyy, HH:mm:ss');

  // Determine the styling based on whether this is the max bid and the current user's bid
  const getBidStyle = () => {
    if (bid.isMaxBid && isCurrentUserBid) {
      return 'bg-success bg-opacity-25'; // Green background for current user's highest bid
    } else if (bid.isMaxBid) {
      return 'bg-warning bg-opacity-25'; // Yellow background for highest bid by someone else
    } else if (isCurrentUserBid) {
      return 'bg-primary bg-opacity-10'; // Light blue for user's other bids
    }
    return '';
  };

  return (
   <ListGroup.Item
   className={`d-flex py-2 ${getBidStyle()}`}
   >
      {/* Left Section: Bidder Name */}
      <Col className='d-flex flex-column w-100'>
        {/* Bidder Name and Amount */}
        <div className='d-flex justify-content-between'>
          <Col className='mb-0 h6' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <span className='fw-semibold'>
              {bid.userName.substring(0, 1)}{bid.userName.length > 1 ? '***' : ''}{bid.userName.slice(-1)}
              {isCurrentUserBid && <Badge bg="secondary" className="ms-1" style={{ fontSize: '0.6rem' }}>You</Badge>}
            </span>
          </Col>
          <Col className='text-end'>
            <span className='fw-semibold'>
              R{bid.bid}
              {bid.isMaxBid && <FaTrophy className="ms-1 text-warning" size={14} />}
            </span>
          </Col>
        </div>

        {/* Timestamp Section */}
        <div className='text-end opacity-60' style={{ fontSize: '0.7rem' }}>
          {formattedDate}
        </div>
      </Col>
    </ListGroup.Item>
  );
}

export default BidList
